import React, { type FC } from "react";
import { RawMoney } from "@edreamsodigeo/prisma-design-system";

import type { Money } from "~/generated/graphql";

interface Props {
  money: Money;
  rounded?: boolean;
}

export const StyledPrice: FC<Props> = ({ money, rounded = false }) => (
  <RawMoney currency={money.currency} rounded={rounded}>
    {money.amount}
  </RawMoney>
);
